"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRAMED_TILE_SIZE_TO_JIG_PROPERTIES = exports.F_LINE_FRAMED_TILE_SIZE_TO_JIG_PROPERTIES = exports.FRAMELESS_TILE_SIZE_TO_JIG_PROPERTIES = void 0;
const tiles_1 = require("./tiles");
exports.FRAMELESS_TILE_SIZE_TO_JIG_PROPERTIES = {
    [tiles_1.TILE_SIZES.SQUARE_4X4]: {
        pageWidth: 4.24,
        pageHeight: 4.24,
        tileWidth: 4.24,
        tileHeight: 4.24,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.SQUARE_8X8]: {
        pageWidth: 9.3,
        pageHeight: 9.3,
        tileWidth: 8.58,
        tileHeight: 8.58,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_8X11]: {
        pageWidth: 9.3,
        pageHeight: 12,
        tileWidth: 8.65,
        tileHeight: 11.25,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_11X8]: {
        pageWidth: 9.3,
        pageHeight: 12,
        tileWidth: 11.25,
        tileHeight: 8.65,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.HONEYCOMB_10X11]: {
        pageWidth: 11.84,
        pageHeight: 10.25,
        tileWidth: 10.25,
        tileHeight: 11.84,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.HONEYCOMB_11X10]: {
        pageWidth: 11.84,
        pageHeight: 10.25,
        tileWidth: 11.84,
        tileHeight: 10.25,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_12X16]: {
        pageWidth: 13.4,
        pageHeight: 17.4,
        tileWidth: 12.69,
        tileHeight: 16.69,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_16X12]: {
        pageWidth: 13.4,
        pageHeight: 17.4,
        tileWidth: 16.69,
        tileHeight: 12.69,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.SQUARE_12X12]: {
        pageWidth: 13.4,
        pageHeight: 13.4,
        tileWidth: 12.69,
        tileHeight: 12.69,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_25X8]: {
        pageWidth: 25.45,
        pageHeight: 8.65,
        tileWidth: 25.45,
        tileHeight: 8.65,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.SQUARE_20X20]: {
        pageWidth: 20.125,
        pageHeight: 22,
        tileWidth: 20,
        tileHeight: 20,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_20X27]: {
        pageWidth: 20.125,
        pageHeight: 29,
        tileWidth: 20,
        tileHeight: 27.5,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_27X20]: {
        pageWidth: 20.125,
        pageHeight: 29,
        tileWidth: 27.5,
        tileHeight: 20,
        shouldShowTileName: true,
        pageMarginTop: 0.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_27X36]: {
        pageWidth: 27,
        pageHeight: 36,
        tileWidth: 27,
        tileHeight: 36,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_36X27]: {
        pageWidth: 27,
        pageHeight: 36,
        tileWidth: 36,
        tileHeight: 27,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_22X44]: {
        pageWidth: 22,
        pageHeight: 44,
        tileWidth: 22,
        tileHeight: 44,
        shouldShowTileName: false,
        pageMarginTop: 0,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_44X22]: {
        pageWidth: 22,
        pageHeight: 44,
        tileWidth: 44,
        tileHeight: 22,
        shouldShowTileName: false,
        pageMarginTop: 0,
    }, // Will be rotated
};
// It seemed to be calculated according to the following formula:
// pageWidth = actualPhysicalSize - 2 * actualFrameWidth + 2 * bleedWidth
// Example of 8X8 tile: 8.4" - 2 * 0.47" + 2 * 0.125" = 7.71"
// An exception are 22X44 and 44X22 which doesn't contain bleed due to different printing mechanism
exports.F_LINE_FRAMED_TILE_SIZE_TO_JIG_PROPERTIES = {
    [tiles_1.TILE_SIZES.SQUARE_4X4]: {
        pageWidth: 3.63,
        pageHeight: 3.63,
        tileWidth: 3.63,
        tileHeight: 3.63,
    },
    [tiles_1.TILE_SIZES.SQUARE_8X8]: {
        pageWidth: 7.71,
        pageHeight: 7.71,
        tileWidth: 7.71,
        tileHeight: 7.71,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_8X11]: {
        pageWidth: 7.71,
        pageHeight: 10.31,
        tileWidth: 7.71,
        tileHeight: 10.31,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_11X8]: {
        pageWidth: 7.71,
        pageHeight: 10.31,
        tileWidth: 10.31,
        tileHeight: 7.71,
    },
    [tiles_1.TILE_SIZES.HONEYCOMB_11X10]: {
        pageWidth: 11.1,
        pageHeight: 9.61,
        tileWidth: 11.1,
        tileHeight: 9.61,
    },
    [tiles_1.TILE_SIZES.HONEYCOMB_10X11]: {
        pageWidth: 11.1,
        pageHeight: 9.61,
        tileWidth: 9.61,
        tileHeight: 11.1,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_12X16]: {
        pageWidth: 11.75,
        pageHeight: 15.75,
        tileWidth: 11.75,
        tileHeight: 15.75,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_16X12]: {
        pageWidth: 11.75,
        pageHeight: 15.75,
        tileWidth: 15.75,
        tileHeight: 11.75,
    },
    [tiles_1.TILE_SIZES.SQUARE_12X12]: {
        pageWidth: 11.75,
        pageHeight: 11.75,
        tileWidth: 11.75,
        tileHeight: 11.75,
    },
    [tiles_1.TILE_SIZES.SQUARE_20X20]: {
        pageWidth: 18.81,
        pageHeight: 18.81,
        tileWidth: 18.81,
        tileHeight: 18.81,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_20X27]: {
        pageWidth: 18.81,
        pageHeight: 26.31,
        tileWidth: 18.81,
        tileHeight: 26.31,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_27X20]: {
        pageWidth: 18.81,
        pageHeight: 26.31,
        tileWidth: 26.31,
        tileHeight: 18.81,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_27X36]: {
        pageWidth: 26.64,
        pageHeight: 35.64,
        tileWidth: 26.64,
        tileHeight: 35.64,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_36X27]: {
        pageWidth: 26.64,
        pageHeight: 35.64,
        tileWidth: 35.64,
        tileHeight: 26.64,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_22X44]: {
        pageWidth: 21.38,
        pageHeight: 43.38,
        tileWidth: 21.38,
        tileHeight: 43.38,
    },
    [tiles_1.TILE_SIZES.RECTANGLE_44X22]: {
        pageWidth: 21.38,
        pageHeight: 43.38,
        tileWidth: 43.38,
        tileHeight: 21.38,
    }, // Will be rotated
};
// Dimensions for the plastic tiles
exports.FRAMED_TILE_SIZE_TO_JIG_PROPERTIES = {
    [tiles_1.TILE_SIZES.SQUARE_8X8]: {
        pageWidth: 8.25,
        pageHeight: 8.25,
        tileWidth: 8.25,
        tileHeight: 8.25,
    },
};
//# sourceMappingURL=createJigs.consts.js.map